export default __webpack_public_path__ + "static/media/Group621@2x.9f020068.png";